import React from "react";
import ReactDOM from "react-dom";
import { observer } from "mobx-react";
import { observable, action } from "mobx";
import { injectIntl } from "react-intl";
import { MentionsInput, Mention } from "react-mentions";
import { MENTIONS_CLASS_NAMES, NOTE_COMMENT_MAX_LENGTH } from "./constants";

@injectIntl
@observer
export default class CommentForm extends React.Component {
  constructor(props) {
    super(props);
  }

  @observable selected = false;

  render() {
    const { note, intl } = this.props;
    const rootStore = note.laneStore.rootStore;
    const commentTextTooLarge =
      note.newCommentText.length >= NOTE_COMMENT_MAX_LENGTH;
    const addButtonDisabled =
      !note.newCommentText.trim() || commentTextTooLarge;
    return (
      <div className="comment-form-container" style={{ position: "relative" }}>
        <div className="comment-form-user-photo-container">
          <img
            className="comment-form-user-photo"
            src={rootStore.user.profilePhotoUrl}
          />
        </div>

        <div className="comment-text-area-container">
          <MentionsInput
            classNames={MENTIONS_CLASS_NAMES}
            value={note.newCommentText}
            onChange={this.handleCommentChange}
            onKeyDown={this.checkKey}
            displayTransform={(id, display, type) => `@${display}`}
            ref={element => (this.MentionsInputComponent = element)}
            markup="@[__display__](/profiles/__id__)"
            onSelect={() => (this.selected = true)}
            onBlur={() => (this.selected = false)}
          >
            <Mention
              className={MENTIONS_CLASS_NAMES.mentions__mention}
              trigger="@"
              data={rootStore.allMembersForMentions}
              appendSpaceOnAdd
            />
          </MentionsInput>
        </div>

        <div className="comment-button-container ">
          {this.selected && (
            <span
              style={{ marginLeft: "50px", color: "#8A9499", float: "left" }}
            >
              {intl.formatMessage({ id: "shift_enter_new_line" })}
            </span>
          )}

          {commentTextTooLarge && (
            <div style={{ marginLeft: "50px" }}>
              <span className="fa fa-exclamation-circle" />
              {intl.formatMessage({ id: "note_text_too_large" })}
            </div>
          )}
          <button
            className="comment-button btn btn-primary pull-right"
            disabled={addButtonDisabled}
            onClick={this.handleCommentSubmit}
            style={{ minWidth: "158px" }}
          >
            {intl.formatMessage({ id: "add_comment" })}
          </button>
        </div>
        <div className="clearfix" />
      </div>
    );
  }

  @action
  handleCommentSubmit = e => {
    const { note } = this.props;
    e.preventDefault();

    if (note.newCommentText.trim()) {
      note.addComment();
    }
  };

  @action
  handleCommentChange = (e, newValue, newPlainTextValue, mentions) => {
    this.props.note.newCommentText = newValue;
  };

  checkKey = e => {
    if (e.key === "Enter" && !e.shiftKey) {
      this.handleCommentSubmit(e);
    }
  };

  componentDidMount() {
    const { note } = this.props;

    note.commentFormTextAreaRef = ReactDOM.findDOMNode(
      this.MentionsInputComponent
    ).childNodes[0].childNodes[1];
  }
}

CommentForm.propTypes = {};
